<template>
  <div>
    <dashboard-tabs />
  </div>
</template>

<script>
export default {
  name: 'Home',

  components: {
    DashboardTabs: () => import('@/modules/dashboard/components/DashboardTabs')
  }
};
</script>
